module.exports = __webpack_public_path__ + "static/media/debt-general-v4.6e64aa8c.svg";